import React from 'react';
import bem from 'utils/bem';
import { useField } from 'formik';
import SelectField from 'forms/fields/SelectField';
import FormError from 'forms/fields/FormError';

import './index.sass';

const options = [
    { label: 'Мужской', value: 'M' },
    { label: 'Женский', value: 'F' },
]

const { cnBlock } = bem('gender-field');
export default ({ className, name, ...rest }) => {

    const [ field, meta ] = useField({ name, type: 'select' });

    return <>
        <SelectField
            className={ cnBlock(className) }
            { ...field }
            { ...rest }
            options={ options }
        />
        { meta.error && meta.touched && <FormError>{ meta.error }</FormError> }
    </>
}
